<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>系统参数</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>系统参数配置</span>
        </div>
        <el-form :model="form" ref="form" label-width="100px" :status-icon="true"
          @submit.native.prevent="submitForm('form')">
          <el-alert type="warning" :closable="true">
            <b>系统参数配置，影响系统运行和结算，请谨慎操作！</b>
          </el-alert>
          <br />

          <el-divider content-position="left">日元汇率</el-divider>
          <el-form-item label="日元汇率" prop="exchangeRate" :rules="[{ required: true, message: '不能为空' }]">
            <el-input type="number" step="0.01" v-model="form.exchangeRate" placeholder="请输入日元汇率">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>

          <el-divider content-position="left">  <el-button type="success" @click="dislogvisibel = true">添加来源</el-button></el-divider>
         
          <el-form-item label="来源关键词">
            <div :key="componentKey">

              <el-tree :data="sourselist">
                <template v-slot:default="{ node, data, store }">
                  <span>{{ data.name }}
                    <div style="display: inline-block;  padding-left: 30px;">
                      <span class="tfbtn" @click="upTF(store, data)">上移</span>
                      <span class="tfbtn" style="padding-left: 10px;" @click="downTF(store, data)">下移</span>
                      <span class="tfbtn" style="padding-left: 10px;color:red;" @click="delResouce(store, data)">删除</span>
                    </div>
                  </span>

                </template>

              </el-tree>
            </div>

          </el-form-item>

          <el-dialog :visible.sync="dislogvisibel">
            <el-form :model="form2" @submit.native.prevent="submitForm2('form2')">
           

              <el-form-item label="输入来源:">
                <el-input placeholder="不选择父菜单则为一级来源" v-model="form2.resouce2" style="width: 240px" ></el-input>
              </el-form-item>

              <el-form-item label="父菜单:">
                <el-select v-model="form2.resouce" clearable placeholder="请选择" style="margin-left: 15px;">
                  <el-option v-for="item in sourselist" :key="item.id" :label="item.name" :value="item.name">{{
          item.name
        }}</el-option>
                </el-select>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
                <el-button @click="dislogvisibel = false">取消</el-button>
              </el-form-item>
            </el-form>
          </el-dialog>
          <el-form-item>
            <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
            <!-- <el-button @click="dialogVisible=false">取消</el-button> -->
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  name: 'site',
  data() {
    return {
      submiting: false,
      form: {}, //参数对象
      form2: {},
      dislogvisibel: false,
      sourselist: [],
      componentKey: 0
    };
  },
  methods: {

    upTF(store, node) {
      const index = this.sourselist.indexOf(node);
      console.log('UP:', index);
      if (index == 0) {
        alert("已经到最上面了")
        return;
      }
      var data = this.sourselist;

      let temp = this.sourselist[index];
      this.$set(this.sourselist, index, this.sourselist[index - 1]);
      this.$set(this.sourselist, index - 1, temp);
      this.updateComponent();

    },
    downTF(store, node) {
      const index = this.sourselist.indexOf(node);
      if (index == this.sourselist.length - 1) {
        alert('已经到最下面了');
        return;
      }

      let temp = this.sourselist[index];
      this.$set(this.sourselist, index, this.sourselist[index + 1]);
      this.$set(this.sourselist, index + 1, temp);
      this.updateComponent();

    },


     deleteNodeAndChildren(parent, index, list) {
    const node = list[index];
    list.splice(index, 1);
    console.log(`删除了节点，索引为: ${index}`);

    if (node.children) {
        node.children.forEach((child, childIndex) => {
            console.log(`子元素索引为: ${childIndex}`);
            // 这里可以根据需要对子元素执行操作
        });
    }

    if (parent) {
        parent.children.splice(index, 1);
    }
},

    

    delResouce(store, node){
     

       
      this.sourselist.forEach((item, index) => {
        if (item === node) {

          const index = this.sourselist.indexOf(node);
          var model=this.sourselist[index]
          var isSuggestion=model.name.includes('推荐');
          if(isSuggestion){
           alert("该字段无法删除");
            return;
      }

          if(confirm('确认删除吗')){
            this.deleteNodeAndChildren(null, index, this.sourselist);
          }
          
        } else if (item.children) {
            item.children.forEach((child, childIndex) => {
                if (child === node) {
                  this.deleteNodeAndChildren(item, childIndex, item.children);
                  alert('删除成功');
                }
            });
        }
    });
  
    },

    updateComponent() {
      this.componentKey += 1;
    },
    //获取配置信息
    getConfig: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      var link = url.getSys("getconfig");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.form = data;
        var keys = JSON.parse(data.keys);
        _this.sourselist = keys.originParam;
      });
    },


    // 上传图片
    initImg: function () {
      var _this = this;
      if ($("#uploadBtnConfig input").length == 0) {
        $("#uploadBtnConfig").uploader({
          url: url.getUpload(),
          text: "上传图片",
          fileExts: "jpg;png;jpeg",
          handleType: "0",
          maxSize: 1024 * 1024 * 0.5,
          onSuccess: function (data) {
            var src = url.getDomain() + data.relativeName;
            _this.$set(_this.form, "shareImg", data.relativeName);
          },
        });
      }
    },
    submitForm2(formName) {
      if (this.form2.resouce == null) {
        this.sourselist.push({ id: `${this.form2.resouce2}`, name: `${this.form2.resouce2}` })

      } else {
        let valueToFind = this.form2.resouce;

        let index = this.sourselist.findIndex(item => item.name === valueToFind);
      
        var thisItem=this.sourselist[index];
        if(!thisItem.children){
          thisItem.children=[];
        }
        thisItem.children.push({ id: `${this.form2.resouce2}`, name: `${this.form2.resouce2}` });
    
      }
      this.dislogvisibel = false;
      this.updateComponent();
    },

    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getSys("saveconfig");
      var info = this.form;
      info.keys=JSON.stringify({originParam:_this.sourselist})
      console.log("info:", info);
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          //添加或者修改
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    //获取服务器列表
    this.getConfig();
    // this.initImg();
  },
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}

.el-form-item--small.el-form-item {
  margin-right: 0px;
}

.el-button--primary {
  margin-left: 10px;
}

.tfbtn {
  font-size: 14px;
  color: lightcoral;

}
</style>
